import {
	CardItem,
	Card as CardContainer,
	Skeleton,
} from "@walmart-web/livingdesign-components"
import React from "react"
import "./index.scss"

function TimeLineSkeleton() {
	return (
		<CardContainer
			role="skeletonview"
			className="timeline-container card-navigation-container"
		>
			<CardItem>
				<div className="card-header">
					<div className="card-title">
						<Skeleton height={20} variant="rounded" />
					</div>
					<div className="card-chips">
						<Skeleton height={30} width={100} variant="rectangle" />
						<Skeleton height={30} width={100} variant="rectangle" />
						<Skeleton height={30} width={100} variant="rectangle" />
						<Skeleton height={30} width={30} variant="rounded" />
					</div>
				</div>
				<Skeleton height={20} className="card-description" variant="rounded" />
				<Skeleton className="card-percentage" variant="rectangle" />
				<Skeleton height={20} className="card-link" variant="rounded" />
			</CardItem>
		</CardContainer>
	)
}

export default TimeLineSkeleton
